export const SEARCH_PARAMS_TAB_KEY = 'tab'
export const SEARCH_PARAMS_WEEK_START_KEY = 'weekStart'
export const SEARCH_PARAMS_RETURN_GROUP_ID_KEY = 'returnToGroupId'

export const VOLUNTEER_TAB_FILTER_SEARCH = 'filter-search' as const

/** Default tab when no ?tab= in URL. Calendar first when STM tabs are visible; otherwise AR Team or Filter/Search. */
export const VOLUNTEER_DEFAULT_TAB_WHEN_STM = 'calendar' as const

/** STM capacity calendar tabs – only when region is STM-enabled and user is Admin or Base Leader */
export const STM_TAB_VALUES = ['calendar', 'groups', 'dashboard'] as const
export type StmTabValue = (typeof STM_TAB_VALUES)[number]

export const STM_TAB_LINKS: { value: StmTabValue; label: string }[] = [
  { value: 'calendar', label: 'Calendar' },
  { value: 'groups', label: 'Groups' },
  { value: 'dashboard', label: 'Dashboard' },
]

/** AR Team tab – Admin/Base Leader Dates Served calendar; visible for all regions (not just STM-enabled) */
export const AR_TEAM_TAB_VALUE = 'ar-team' as const
export type ArTeamTabValue = typeof AR_TEAM_TAB_VALUE

export const AR_TEAM_TAB_LINK: { value: ArTeamTabValue; label: string } = {
  value: AR_TEAM_TAB_VALUE,
  label: 'AR Team',
}

export type VolunteerTabValue = typeof VOLUNTEER_TAB_FILTER_SEARCH | StmTabValue | ArTeamTabValue

/**
 * Region ids where STM tabs (Calendar, Dashboard, Groups, Blocks) are hidden.
 * Tabs are shown by default for all other regions when user is Admin or Base Leader.
 * Add region ids here to hide the tabs for new regions until they are ready.
 */
export const STM_HIDDEN_REGION_IDS: number[] = [1]

/** Returns true when STM tabs should be visible for the given region (not in hidden list and region is set). */
export function isStmTabsVisibleForRegion(regionId: number | undefined): boolean {
  return regionId != null && !STM_HIDDEN_REGION_IDS.includes(regionId)
}
